import { useEffect } from "react";
import { ProjetosFormInicial } from "src/components/projetos/FormInicial";
import { EdicaoLayout } from "src/components/projetos/edicao/layouts/EdicaoLayout";
import { appStore } from "src/framework/store/AppStore";

const PAGE_TITLE = 'Edição projeto'

const ProjetosFormInicialEdicaoPage = () => {
  useEffect(() => {
    appStore.setPageTitle(PAGE_TITLE);
    return () => {
      appStore.setPageTitle("");
    }
  }, [])
  
  return (
    <EdicaoLayout>
      <div className="container">
        <div className="row">
          <div className="X12">
            <ProjetosFormInicial />
          </div>
        </div>
      </div>
    </EdicaoLayout>
  );
};

export { ProjetosFormInicialEdicaoPage };